import { toVendorDeviceDeliveryFields } from '../../../utils/vendorDeviceSubmit';

function normalizeGpuCard(
  gpu: Record<string, unknown>,
): Record<string, { request?: string | number; limit?: string | number }> | undefined {
  const card = gpu.card;
  if (!card || typeof card !== 'object' || Array.isArray(card)) return undefined;

  const cardObj = card as Record<string, unknown>;
  const hasRecordEntry = Object.entries(cardObj).some(
    ([key, value]) => key !== 'name' && key !== 'request' && value != null && typeof value === 'object',
  );
  if (hasRecordEntry) {
    return cardObj as Record<string, { request?: string | number; limit?: string | number }>;
  }

  const cardName = cardObj.name ?? gpu.name;
  const cardRequest = cardObj.request ?? gpu.number;
  if (cardName == null || cardRequest == null || String(cardName).trim() === '') {
    return undefined;
  }

  const request = typeof cardRequest === 'number' || typeof cardRequest === 'string' ? cardRequest : Number(cardRequest);
  return {
    [String(cardName)]: {
      request,
      limit: request,
    },
  };
}

export function readCiGpuFromForm(raw: unknown) {
  if (!raw || typeof raw !== 'object') return undefined;
  const gpu = raw as Record<string, unknown>;
  if (!gpu.vendor && !gpu.device && !gpu.vendorID && !gpu.deviceID && !gpu.vendorId && !gpu.deviceId) return undefined;

  const card = normalizeGpuCard(gpu);
  const quantityUnit = gpu.quantityUnit != null && String(gpu.quantityUnit).trim() !== '' ? String(gpu.quantityUnit).trim() : undefined;
  const deviceType = gpu.deviceType != null && String(gpu.deviceType).trim() !== '' ? String(gpu.deviceType).trim() : undefined;
  return {
    vendor: gpu.vendor as string | undefined,
    device: gpu.device as string | undefined,
    vendorID: (gpu.vendorID ?? gpu.vendorId) as string | undefined,
    deviceID: (gpu.deviceID ?? gpu.deviceId) as string | undefined,
    number: gpu.number as number | string | undefined,
    name: gpu.name as string | undefined,
    code: gpu.code as string | undefined,
    driverVersion: gpu.driverVersion as string | undefined,
    cudaVersion: gpu.cudaVersion as string | undefined,
    ...(deviceType ? { deviceType } : {}),
    ...(quantityUnit ? { quantityUnit } : {}),
    ...(card ? { card } : {}),
  };
}

/** 提交前将表单 GPU 转为 API / deliveryMetadata：仅 vendorID/deviceID */
export function serializeContainerGpu(gpu: Record<string, unknown> | undefined) {
  if (!gpu) return undefined;
  const hasId = Boolean(gpu.vendorID || gpu.vendorId || gpu.deviceID || gpu.deviceId);
  const hasName = Boolean(gpu.vendor || gpu.device);
  if (!hasId && !hasName) return undefined;
  const normalized = readCiGpuFromForm(gpu);
  if (!normalized) return undefined;
  return {
    ...toVendorDeviceDeliveryFields(normalized),
    number: normalized.number,
    name: normalized.name,
    code: normalized.code,
    driverVersion: normalized.driverVersion,
    cudaVersion: normalized.cudaVersion,
    ...(normalized.card ? { card: normalized.card } : {}),
  } as Record<string, unknown>;
}
